<div class="patient-provider-cell">
    <span class="patient-provider-cell__name text-ellipsis">{{ label }}</span>
    <app-patient-chip [label]="compact ? ('shared.patient-chip.abbreviation' | exp:'':'P') : ('shared.patient-chip.patient' | exp:'':'Paciente')" [compact]="compact"></app-patient-chip>
</div>
